<template>
    <div>
        <Popup size="lg" ref="confirm"  title="TITULO MAMALON"> 
                <div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 75vh;">
                    <iframe title="titulo mamalon" class="embed-responsive-item" src="https://s3-us-west-2.amazonaws.com/dev-myfrac/constructionWorkers/4c609009-72c0-4f50-b9ec-62bcbe8926ba.pdf" allowfullscreen></iframe>
                </div>
                 <div class="accordion__button">
            <btn style="float: left;" text="CERRAR" @onClick="openModal" type="primary-block" />
        </div>
        </Popup>
        <button class="btn btn-primary" @click="openModal">Abrir modal</button>
        <!-- <div class="accordion__container">
            <div class="vertical-center">
                <AccordionHeader />
                <Accordion title="Uno" id="first">
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                </Accordion>
                <Accordion title="Dos" id="second">
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                </Accordion>
                <Accordion title="Tres" id="third">
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                </Accordion>
                <Accordion title="Cuatro" id="third">
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                </Accordion>
                <Accordion title="Cinco" id="third">
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa<br>
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                        Accordion Component pa
                </Accordion>
                <div class="accordion__button">
                    <btn style="float: right;" text="guardar y salir" type="primary-block" />
                </div>
            </div>
        </div> -->
        <Loader v-show="false" />
        <Footer />
    </div>  
</template>
<script>
    import Accordion from "../core/Accordion";
    import AccordionHeader from "../core/Accordion/Header";
    import Btn from "../core/Button";
    //import BeneficiaryModal from "../content/BeneficiaryModal";
    import Pagination from "../core/Pagination";
    import Loader from "../core/Loader"
    import Popup from "../core/Popup"
    import Footer from "../core/Footer.vue"

    export default {
        name: "TestComponent",
        components: {
            Accordion,
            AccordionHeader,
            Btn,
            //BeneficiaryModal,
            Pagination,
            Loader,
            Popup,
            Footer
        },
        methods: {
            openModal(){
                this.$refs.confirm.toggleModal();
            }
        }
    }
</script>